import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  [
    'WebformElementCheckboxes',
    'WebformElementRadios',
    'WebformElementWebformCheckboxesOther',
    'WebformElementWebformRadiosOther',
  ],
  (item) => {
    if (item.element.__typename === 'WebformElementCheckboxes') {
      return {
        $formkit: 'checkbox',
        help: item.description,
        __raw__sectionsSchema: {
          help: {
            attrs: {
              innerHTML: item.description,
            },
          },
        },
        options: item.element.options,
      }
    }
    if (item.element.__typename === 'WebformElementWebformCheckboxesOther') {
      return {
        $formkit: 'checkbox',
        options: item.element.checkboxes?.options,
      }
    }
    if (item.element.__typename === 'WebformElementWebformRadiosOther') {
      return {
        $formkit: 'radio',
        options: item.element.radios?.options,
      }
    }
    return {
      $formkit: 'radio',
      options: item.element.options,
    }
  },
)
